import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: {},
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    state.app.receptores.info = {
      ...state.app.receptores.info,
      ...data,
    };
  });
};

const info = async (store, id, params = {}) => {
  store.setState((state) => {
    state.app.receptores.info.busy = true;
  });

  try {
    const response = await Http.get(`api/receptores/${id}`, { params });

    store.setState((state) => {
      state.app.receptores.info.busy = false;
      state.app.receptores.info.data = response.data;
    });
  } catch (error) {
    store.setState((state) => {
      state.app.receptores.info.busy = false;
      state.app.receptores.info.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.receptores.info.busy = { ...initialState };
  });
};

const ReceptorInfoStore = {
  state: () => initialState,
  actions: {
    setPartialState,
    info,
    reset,
  },
};

export default ReceptorInfoStore;
